import {
  faArrowLeftArrowRight,
  faGrid2,
  faHandsHoldingDiamond,
  faLayerGroup,
  faPeopleGroup,
  faShieldCheck,
  faUpload,
  faWreathLaurel,
} from "@icons/duotone";

export const NavigationMenuConfig = {
  products: {
    title: "Product",
    items: {
      column1: {
        heading: "Create",
        gradient: "linear-gradient(90deg, #0B967D 0%, #043028 100%)",
        items: [
          {
            title: "Sections",
            icon: faGrid2,
            description: "Bring your story to life with the building blocks of Shorthand.",
            href: "/features/sections",
          },
          {
            title: "Editor & layout",
            icon: faLayerGroup,
            description: "Design something beautiful with ease. Start with AI, templates, and more.",
            href: "/features/editor-and-layout",
          },
          {
            title: "Branding",
            icon: faWreathLaurel,
            description: "Build brand coherence with themes and styling options.",
            href: "/features/branding/",
          },
        ],
      },
      column2: {
        heading: "Manage",
        gradient: "linear-gradient(90deg, #C69748 0%, #604923 100%)",
        items: [
          {
            title: "Collaborate",
            icon: faPeopleGroup,
            description: "Empower your team with a suite of collaborative features.",
            href: "/features/collaboration/",
          },
          {
            title: "Publish & host",
            icon: faUpload,
            description: "Publish and host stories seamlessly on multiple platforms.",
            href: "/features/publishing-and-hosting/",
          },
        ],
      },
      column3: {
        heading: "Scale",
        gradient: "linear-gradient(90deg, #B660BD 0%, #542C57 100%)",
        items: [
          {
            title: "Integrations",
            icon: faArrowLeftArrowRight,
            description: "Connect Shorthand to your favourite tools.",
            href: "/features/integrations/",
          },
          {
            title: "Support",
            icon: faHandsHoldingDiamond,
            description: "Fuel your storytelling journey with industry-leading support.",
            href: "/features/support/",
          },
          {
            title: "Security",
            icon: faShieldCheck,
            description: "Ensure your work stays safe and meets compliance.",
            href: "/features/security/",
          },
        ],
      },
    },
  },
  solutions: {
    title: "Solutions",
    items: [
      {
        title: "Brand storytelling",
        description: "Promote your brand and products with immersive digital content.",
        href: "/use-cases/brand-storytelling/",
      },
      {
        title: "Digital magazines",
        description: "Grow audience engagement with visually stunning stories at scale.",
        href: "/use-cases/digital-magazines/",
      },
      {
        title: "Annual reports",
        description: "Turn impact into action and captivate your readers.",
        href: "/use-cases/annual-reports/",
      },
      {
        title: "Data storytelling",
        description: "Transform numbers into narratives with powerful data storytelling.",
        href: "/use-cases/data-storytelling/",
      },
      {
        title: "Sponsored content",
        description: "Produce outstanding results for your content partners.",
        href: "/use-cases/sponsored-content/",
      },
      {
        title: "More use cases",
        description: "Discover more ways to build all of your visual content with Shorthand.",
        href: "/use-cases/",
      },
    ],
  },
  inspiration: {
    title: "Inspiration",
    items: [
      {
        title: "Templates",
        description: "Kickstart your story with professionally crafted templates.",
        href: "/templates/",
      },
      {
        title: "Example stories",
        description: "Be inspired by the best digital content on the web.",
        href: "/featured/stories/",
      },
      {
        title: "Case studies",
        description: "Customer success stories from industry leaders.",
        href: "/case-studies/",
      },
    ],
  },
  resources: {
    title: "Resources",
    items: [
      {
        title: "Webinars & training",
        description: "Free introductions to digital storytelling from our expert team.",
        href: "/training/",
      },
      {
        title: "Help docs",
        description: "Learn how to build and publish stunning stories with Shorthand.",
        href: "https://support.shorthand.com/en",
      },
      {
        title: "The Craft magazine",
        description: "Tips, insights, and inspiration on the craft of digital storytelling.",
        href: "/the-craft/",
      },
    ],
  },
  enterprise: {
    title: "Enterprise",
    href: "/enterprise/",
  },
  pricing: {
    title: "Pricing",
    href: "/pricing/",
  },
};
